import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Input, Col, Row, Label } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import './index.css';
import UserObject from '../../components/UserObject';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class MyProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            isLoading: false,
        }
    }
    componentWillMount() {
        this.getCurrentUser();
    }
    componentDidMount = () => {
        document.title = "My Profile - DataDex";
    }
    updateObject(attribute, value) {
        const { user } = this.state;
        user[attribute] = value
        this.setState({ user });
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: 'user/me',
            success: (response) => {
                if (response.status === 'ok') {
                    this.setState({ user: response.user })
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    changePassword() {
        const changePasswordConfirm = window.confirm('Are you sure to change your password?');
        if (!changePasswordConfirm) return;
        const { user } = this.state;
        this.setState({ isLoading: true });
        if (user.new_password) {
            api.fetchAPI({
                method: 'post',
                uri: `user/${user.id}/reset_password`,
                body: user,
                success: (response) => {
                if (response.status === 'ok') {
                    alert(`User new password is: ${response.new_password}`)
                } else {
                    alert('Error');
                    console.log(response);
                }
                },
                error: (error) => {
                console.error(error);
                }
            });
          this.setState({ isLoading: false });
        } else {
            alert('New password cannot be blank');
        }
    }
    updateUser() {
        const { user } = this.state;
        this.setState({ isLoading: true });
        console.log('user', user);
        delete user.permissions;
        api.fetchAPI({
            method: 'put',
            uri: 'users',
            body: user,
            success: (response) => {
                if (response.status === 'ok') {
                    alert('User information has been updated');
                } else {
                    alert('Error');
                    console.log(response);
                }
            },
            error: (error) => {
                console.error(error);
            }
        });
        this.setState({ isLoading: false });
    }
    render() {
        const { user, isLoading} = this.state;
        if (!user) return null;
        return (
            <div style={{ marginTop: 50 }}>
                <Row>
                    <Col xs={12} sm={12} md={6} className="home-search-result-item">
                        <h4>Personal information</h4>
                        <FormGroup>
                            <Label>First name</Label>
                            <Input
                                type="text"
                                value={user.first_name || ''}
                                onChange={(e) => this.updateObject('first_name', e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Middle name</Label>
                            <Input
                                type="text"
                                value={user.middle_name || ''}
                                onChange={(e) => this.updateObject('middle_name', e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Last name</Label>
                            <Input
                                type="text"
                                value={user.last_name || ''}
                                onChange={(e) => this.updateObject('last_name', e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Button
                                color="success"
                                onClick={() => this.updateUser()}
                            >
                                {isLoading ? 'Saving...' : 'Save'}
                            </Button>
                        </FormGroup>
                    </Col>
                    <Col xs={12} sm={12} md={6} className="home-search-result-item">
                        <h4>Change password</h4>
                        <FormGroup>
                            <Label>New password</Label>
                            <Input
                                type="password"
                                value={user.new_password}
                                onChange={(e) => this.updateObject('new_password', e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Button
                                color="warning"
                                onClick={() => this.changePassword()}
                            >
                                Change password
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/MyProfile/index.js